<template>
  <div class="animate__animated animate__fadein animate__delay-0.5s animate__slower">
    <div style="height: 100%;width: .3229rem;background: rgb(1, 162, 153);position: fixed;top: 0;left: 0;"></div>

    <navTeacher></navTeacher>
    <div style="width: .7292rem;height: .1094rem;margin: .2083rem 0 .0573rem 1.349rem;
color: rgb(0, 0, 0);
font-family: Microsoft YaHei;
font-size: .0833rem;
font-weight: 400;
line-height: .1094rem;;">学君教育>寻找学员</div>
    <div style="display: flex;width: 7.2917rem;height: 1.4427rem; margin: 0 auto ;background: rgb(245, 245, 245);">
      <img src="../../assets/filterline.png" alt="">
      <div class="filter">
        <div>
          <span class="title">求教年级:</span>
          <el-radio-group v-model="grade">
            <el-radio-button v-for="item in  gradeList " :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <el-radio-group v-model="subject"> <span class='title' style="transform: translateY(.0304rem);">求教科目:</span>
            <el-radio-button v-for=" item  in  subjectList " :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
          </el-radio-group>
        </div>
        <div style="display: flex;">
          <span class='title' style="width: .38rem;transform: translateY(.04rem);">授课区域:</span>
          <el-radio-group v-model="area">
            <el-radio-button v-for=" item  in  areaList " :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <span class='title'>辅导方式:</span>
          <el-radio-group v-model="methods">
            <el-radio-button v-for=" item  in  methodsList " :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
          </el-radio-group>
        </div>
        <!-- <div>

          <el-radio-group v-model="school"><span class='title'>所在高校:</span>
            <el-radio-button v-for="item in schoolList" :key="item" :label="item"></el-radio-button>
          </el-radio-group>
        </div> -->
        <div>

          <el-radio-group v-model="degree"> <span class='title'>学历要求:</span>
            <el-radio-button v-for=" item  in  degreeList " :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
          </el-radio-group>
        </div>
        <div>
          <span class='title'>学员性别:</span>
          <el-radio-group v-model="sex">
            <el-radio-button v-for=" item  in  sexList " :key="item.value" :label="item.value">{{ item.label
              }}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <!-- <students></students> -->
    <div class="t" id="students">
      <el-empty description="暂无对应的学员" v-if="currentitems.length == 0"
        style="margin: 0 auto; transform: translateY(-1.5rem);"></el-empty>
      <div class="box" v-for="item in currentitems" :key="item.id">
        <div class="title"><span>&lt;{{ allgradeId[item.gradeId] }}&gt;{{ item.subject }}</span></div>
        <div class="describtion">学员描述：</div>
        <div class="content">{{ item.studentLearningSituation }}</div>
        <div class="look" @click="$router.push('/teacherlook#' + item.did)"></div>
        <div class="line"></div>
        <div class="bottom">
          <div class="infor">
            <div class="area">授课区域： {{ allstudyArea[item.studyArea] }} </div>
            <div class="money">课时费: <span>{{ item.price }}元/时</span></div>
          </div>
          <button class="send" @click="toudi(item.did)">投递简历</button>
        </div>
      </div>
      <div class="pagination" v-if="!(currentitems.length == 0)">
        <!-- <div class="first" @click="pageindex = 1">首页</div> -->
        <el-pagination layout="prev, pager, next" :total="total" :page-size="9" :current-page="parseInt(pageindex)"
          :pager-count="7" @current-change="change" :key="pageindex">
        </el-pagination>
        <!-- <div class=" first" @click="pageindex = totalpages">尾页
      </div> -->
        <div class="txt">前往</div>
        <input type="text" v-model.lazy="pageindex">
        <div class="txt2">页</div>

      </div>
    </div>
  </div>
</template>

<script>
import navTeacher from '../layout/nav-teacher.vue';
export default {
  components: {
    navTeacher,
  },
  data() {
    return {
      a: [1, 2],
      totalitems: [],
      total: 0,
      pageindex: 1,
      currentitems: [],
      allstudyArea: ['锦江区', '金牛区', '武侯区', '青羊区', '成华区', '高新区', '天府新区', '新都区', '郫都区', '双流区', '龙泉驿区', '温江区', '其他', '都江堰', '彭州', '邛崃', '崇州', '简阳', '金堂', '大邑', '蒲江', '新津', '青白江'],
      studyArea: 0,
      allgradeId: ["小学", "初中", "高中"],
      teachertype: ['专职教师', '在读本科生', '在读研究生'],
      pageindex: 1,
      // gradeList: ['不限', '小学', '初中', '高中',],
      gradeList: [{
        value: 999,
        label: '不限'
      }
        , {
        value: 0,
        label: '小学'
      },
      {
        value: 1,
        label: '初中'
      },
      {
        value: 2,
        label: '高中'
      },],
      grade: 999,
      // subjectList: ['不限', '语文', '数学', '英语', '物理', '化学', '生物', '政治', '历史', '地理', '计算机', '小语种', '艺体类'],
      subjectList: [{
        value: 999,
        label: '不限'
      },
      {
        value: 1,
        label: '语文'
      },
      {
        value: 2,
        label: '数学'
      },
      {
        value: 3,
        label: '英语'
      },
      {
        value: 4,
        label: '物理'
      },
      {
        value: 5,
        label: '化学'
      },
      {
        value: 6,
        label: '生物'
      },
      {
        value: 7,
        label: '政治'
      },
      {
        value: 8,
        label: '历史'
      },
      {
        value: 9,
        label: '地理'
      },
      {
        value: 10,
        label: '计算机'
      },
      {
        value: 11,
        label: '小语种'
      },
      {
        value: 12,
        label: '艺体类'
      },],
      subject: 999,
      area: 999,
      areaList: [{
        value: 999,
        label: '不限'
      },
      {
        value: 0,
        label: '锦江区'
      }, {
        value: 1,
        label: '金牛区'
      }, {
        value: 2,
        label: '武侯区'
      }, {
        value: 3,
        label: '青羊区'
      }, {
        value: 4,
        label: '成华区'
      }, {
        value: 5,
        label: '高新区'
      }, {
        value: 6,
        label: '天府新区'
      }, {
        value: 7,
        label: '新都区'
      }, {
        value: 8,
        label: '郫都区'
      }, {
        value: 9,
        label: '双流区'
      }, {
        value: 10,
        label: '龙泉驿区'
      }, {
        value: 11,
        label: '温江区'
      }, {
        value: 13,
        label: '都江堰'
      }, {
        value: 14,
        label: '彭州'
      }, {
        value: 15,
        label: '邛崃'
      }, {
        value: 16,
        label: '崇州'
      }, {
        value: 17,
        label: '简阳'
      }, {
        value: 18,
        label: '金堂'
      }, {
        value: 19,
        label: '大邑'
      }, {
        value: 20,
        label: '蒲江'
      }, {
        value: 21,
        label: '新津'
      }, {
        value: 22,
        label: '青白江'
      },
      {
        value: 12,
        label: '其他'
      },
      ],
      methods: 999,
      // methodsList: ['不限', '老师上门', '线上辅导'],
      methodsList: [{
        value: 999,
        label: '不限',
      }, {
        value: 0,
        label: '老师上门',
      },
      {
        value: 1,
        label: '线上辅导',
      }],
      degree: 999,
      // degreeList: ['不限', '本科生', '研究生', '博士生', '教培行业在职老师', '非教培行业专职老师'],
      degreeList: [{
        value: 999,
        label: '不限'
      }, {
        value: 1,
        label: '本科生'
      }
        , {
        value: 2,
        label: '研究生'
      },
      {
        value: 3,
        label: '专职教师'
      },
      ],
      sex: 999,
      // sexList: ['不限', '男学员', '女学员'],
      sexList: [{
        value: 999,
        label: '不限'
      },
      {
        value: 1,
        label: '男学员'
      },
      {
        value: 2,
        label: '女学员'
      },],
      Authorization: ''
    }
  },
  created() {
    this.Authorization = localStorage.getItem('Authorization');
    this.$http.get('/Api/Teacher/web/Demands', {
      params: {
        pageNumber: 1,
        pageSize: 9,
      },
      headers: {
        'Authorization': this.Authorization
      }
    }).then(res => {
      console.log(res.data.data);
      this.total = res.data.data.total
      this.currentitems = Array.from(res.data.data.records)
    })
  },
  watch: {
    pageindex(n, o) {
      if (n !== o) {
        if (isNaN(parseInt(n))) {
          this.$message({
            message: '请输入数字',
            type: 'warning'
          });
          this.pageindex = o
          return false
        }
        if (n > Math.ceil(this.total / 9) || n < 1) {
          this.$message({
            message: '您输入的范围不对哦~~',
            type: 'warning'
          });
          this.pageindex = o
          return false
        }
        this.pageindex = n
        this.$http.get('/Api/Teacher/web/Demands', {
          params: {
            pageNumber: n,
            pageSize: 9,
          },
          headers: {
            'Authorization': this.Authorization
          }
        }).then(res => {
          console.log(res.data.data.records);
          this.currentitems = Array.from(res.data.data.records)
        })
      }
    },
    subject(n, o) {
      // let a = [];
      // if (this.subject.length > 1 && JSON.stringify(n) !== JSON.stringify(o)) {
      //   if (this.subject[this.subject.length - 1] != '不限') {
      //     this.subject.forEach((item) => {
      //       if (item != '不限') {
      //         a.push(item)
      //       }
      //     })
      //     this.$set(this, 'subject', a)
      //   }
      //   else {
      //     this.$set(this, 'subject', ['不限'])
      //   }
      // }
      this.changedata()
    },
    degree(n, o) {
      // let a = [];
      // if (this.degree.length > 1 && JSON.stringify(n) !== JSON.stringify(o)) {
      //   if (this.degree[this.degree.length - 1] != '不限') {
      //     this.degree.forEach((item) => {
      //       if (item != '不限') {
      //         a.push(item)
      //       }
      //     })
      //     this.degree = a
      //   }
      //   else {
      //     this.degree = ['不限']
      //   }
      // }
      this.changedata()
    },
    sex() {
      this.changedata()
    },
    grade() {
      this.changedata()
    },
    area() {
      this.changedata()
    },
    methods() {
      this.changedata()
    },


  },
  methods: {
    change(index) {
      this.pageindex = index
    },
    toudi(a) {
      this.$http.get('/Api/Teacher', {
        headers: {
          'Authorization': this.Authorization
        }
      }).then(res => {
        if (res) {
          this.$http.post('/Api/Teacher/Apply/' + a, {}, {
            headers: {
              'Authorization': this.Authorization
            }
          }).then(res => {
            console.log(res);
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          })
        }

      }).catch(err => {
        this.$message({
          message: '请先完善个人信息',
          type: 'warning'
        });
        this.$router.push('/personteacher/jianli')
      })


    },
    changedata() {
      let newdata = {}
      if (this.sex != 999) {
        newdata.gender = this.sex
      }
      if (this.grade != 999) {
        newdata.gradeId = this.grade
      }
      if (this.subject != 999) {
        newdata.itemId = this.subject
      }
      if (this.area != 999) {
        newdata.areaId = this.area
      }
      if (this.methods != 999) {
        newdata.isOnline = this.methods
      }
      if (this.degree != 999) {
        newdata.teacherType = this.degree
      }
      if (this.subject == 10) {
        newdata.gradeId = 6
        delete newdata.itemId;
      }
      if (this.subject == 11) {
        newdata.gradeId = 3
        delete newdata.itemId;
      }
      if (this.subject == 12) {
        newdata.gradeId = 4
        delete newdata.itemId;
      }
      console.log(newdata);
      this.$http.get('/Api/Teacher/web/Demands', {
        params: {
          ...newdata,
          pageSize: 9,
          pageNumber: this.pageindex
        },
        headers: {
          'Authorization': this.Authorization
        }
      }).then(res => {
        let alldata = res.data.data.records
        this.total = res.data.data.total
        this.currentitems = alldata
      })
    }
  }

}
</script>

<style scoped>
.t {
  width: 1400px;
  height: 1000px;
  margin: 42px auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  gap: 40px
}

.t .box {
  width: 440px;
  height: 320px;
  background: rgb(245, 245, 245);
  margin-top: 40px;
}

#students .title {
  width: 440px;
  height: 50px;
  margin-top: 15px;
  background: url('../../assets/studentstitlebg.png') no-repeat;
  background-size: 100% 100%;
}

#students .title span {
  /* <三年级> 全科 */
  display: inline-block;
  width: 136px;
  height: 26px;
  margin-left: 59px;
  margin-top: 11.5px;
  color: rgb(245, 245, 245);
  font-family: Microsoft YaHei;
  font-size: 20px;
  font-weight: 700;
  line-height: 26px;
  letter-spacing: 0px;
  text-align: left;
}

.describtion {
  /* 学员描述： */
  display: inline-block;
  width: 384px;
  height: 21px;
  color: rgb(1, 162, 153);
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 30px;
  margin-top: 17px;
}

.content {
  /* 学生各科成绩都比较一般，数学有短板，性格活泼好动，就是不太自律，希望老师能为孩子辅导家庭作业，在学校上课教的内容的基础上做一些补充，让孩子能有一些提高。 */
  width: 384px;
  height: 71px;
  color: rgb(0, 0, 0);
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
  margin-left: 30px;
  margin-top: 7px;
  text-indent: 2em;
  display: -webkit-box;
  /* 必须配合这个属性使用 */
  -webkit-box-orient: vertical;
  /* 必须配合这个属性使用 */
  -webkit-line-clamp: 4;
  /* 限制行数为3行 */
  overflow: hidden;
  /* 隐藏超出的文本 */
  text-overflow: ellipsis;
  word-wrap: break-word;
}

.look {
  width: 90px;
  height: 24px;
  background: url('../../assets/studentlook.png') no-repeat;
  background-size: 100% 100%;
  margin-top: 25px;
  margin-left: 313px;
}

.line {
  /* 分隔栏 */
  width: 438px;
  height: 0;
  border: 1px solid rgb(196, 196, 196);
  margin-top: 10px;
}

.bottom {
  width: 380px;
  height: 44px;
  margin-left: 30px;
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
}

.bottom .infor {
  width: 147px;
  height: 44px;
  color: rgb(0, 0, 0);
  font-family: Microsoft YaHei;
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: 0px;
  text-align: left;
}

.bottom .infor .money {
  margin-top: 10px;
}

.bottom .infor .money span {
  color: rgb(176, 0, 32);
  font-weight: 600;

}

.bottom .send {
  width: 149px;
  height: 44px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  border: none;
  /* Small Button */
  color: rgb(255, 254, 254);
  font-family: Microsoft YaHei;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  /* margin-left: 20px; */
}

.t /deep/ .el-pager .active {
  background: rgb(1, 162, 153);
  color: rgb(245, 245, 245);
}

.t /deep/ .el-pager .number {
  /* 页1 */
  width: 35px;
  height: 35px;
  border-radius: 4px;
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  margin-left: 5.5px;
  margin-right: 5.5px;
  background: rgb(240, 242, 245);
  color: rgb(96, 98, 102);
}

.t /deep/ .el-pager .active {
  background: rgb(1, 162, 153);
  color: rgb(245, 245, 245);
}

.t /deep/ .el-pagination button {
  /* 上一页 */
  height: 35px;
  background: rgb(245, 245, 245);
  border-radius: 4px;
  color: rgb(0, 0, 0);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  padding: 0 !important;

}

/* .t /deep/ .el-pagination button,
  .t /deep/ .el-pagination li {
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  } */

.t .first,
.t /deep/ .pagination input {
  /* box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); */
  margin-top: 3px;
}

.t /deep/ .el-pagination .more {
  /* box-shadow: none !important; */
  /* color: rgb(1, 162, 153); */
  /* margin-top: 5px; */
  background: rgb(240, 242, 245);
  width: 32px;
  height: 35px;
  border-radius:
    2px;
  /* font-size: 30px; */
  padding-top: 3px;
}

.pagination {
  margin-top: 100px;
  display: flex;
  width: 100vw;
  height: 100px;
  justify-content: center;
  gap: 11px
}

.pagination .first {
  width: 46px;
  height: 35px;
  background: rgb(1, 162, 153);
  border-radius: 4px;
  /* 首页 */
  color: rgb(245, 245, 245);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: center;
  cursor: pointer;
}

.pagination .txt {
  /* 共 5 页 前往 */
  width: 40px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;
  transform: translateX(10px);
}

.pagination input {
  /* 选页 */
  width: 60px;
  height: 35px;
  background: rgb(245, 245, 245);
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  text-align: center;
}

.pagination .txt2 {
  /* 页 */
  width: 15px;
  height: 35px;
  color: rgb(96, 98, 102);
  font-family: Noto Sans SC;
  font-size: 15px;
  font-weight: 400;
  line-height: 35px;
  letter-spacing: 0px;
  text-align: left;
  cursor: pointer;

}


.filter .title {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  line-height: 21px;
  transform: translateY(3px);

}

.filter {
  padding-left: 45px;
  padding-top: 10px;
  padding-bottom: 30px;
  height: 267px;
  box-sizing: border-box;

}

/deep/ .el-radio-button__inner {
  border: none !important;
  background: rgb(245, 245, 245) !important;

}

/deep/ .is-active .el-radio-button__inner {
  background: rgb(245, 245, 245) !important;
  border: none;
  font-weight: 700;
  color: rgb(42, 177, 141);
  -webkit-box-shadow: none !important;
  box-shadow: transparent !important;
}

/deep/ .el-radio-button__inner {
  border: none !important;
  background: rgb(245, 245, 245) !important;

}

/deep/ .is-checked .el-radio-button__inner {
  background: rgb(245, 245, 245) !important;
  border: none !important;
  color: rgb(42, 177, 141);
  font-weight: 700;
  -webkit-box-shadow: none !important;
  box-shadow: transparent !important;
}

/deep/ .el-radio-button span,
/deep/ .el-radio-button span {
  font-size: 16px;
  line-height: 21px;
  font-weight: 400;
  padding: 8px 5px 8px 5px;
}

.el-radio-group .title {
  transform: translateY(6px);
  padding-right: 3px;
}

.el-checkbox-group .title {
  transform: translateY(6px);
  padding-right: 3px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/find-student.vue